import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './AuthorBio.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { IAuthor } from '../../types/shared/Author';
import { Section, Row, Image } from '../../importCL';

interface IAuthorBioProps extends MappedComponentProperties {
    author?: IAuthor;
    authorPage?: boolean;
}

export const AuthorBioEditConfig = {
    emptyLabel: 'Author Bio',
    isEmpty: (props: PropsWithChildren<IAuthorBioProps>) => {
        return !props || !props.author?.authorName;
    },
};
const AuthorBio = (props: PropsWithChildren<IAuthorBioProps>): JSX.Element => {
    const authorPageLink = '/content/cob-corp-acquisition/us/en/articles/author/' + props.author?.authorPageName;
    return (
        props.author ?
            <Section id='author-bio' className={`!pt-8 pb-5 !px-0 ${props.authorPage ? '' : ' !pt-8 !px-0 !pb-0'}`}>
                {!props.authorPage && <hr className='border-t border-[#ddd]'/>}
                <Row className='pt-2 px-6 pb-10'>
                    <div className='text-center py-0 px-1 w-1/6 lg:w-full lg:text-center'>
                        <Image loading='lazy' className='AuthorBio__image' src={props.author.authorImage} alt={props.author.authorImageAltText ? props.author.authorImageAltText : 'Photo of the author'}/>
                    </div>
                    <div className='w-5/6 lg:w-full lg:text-center'>
                        {!props.authorPage &&   <p className='text-base !font-semibold mb-[0.375rem]'>About the author:</p>}
                        {props.authorPage
                            ? <h1 className='AuthorBio__authorName text-grey-tundora cursor-none'>{props.author.authorName}</h1>
                            : <a className='AuthorBio__authorName' href={authorPageLink}>{props.author.authorName}</a>
                        }
                        <span>{transformHTMLParserLinks(props.author.authorDescription ?? '')}</span>
                    </div>
                </Row>
            </Section>
            : <></>
    );
};

export default AuthorBio;
